/* eslint-disable react/prop-types */
// @flow

// Standard Pakete
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import { hot } from 'react-hot-loader'

// hinzugefügte Pakete
import { Masthead } from '@ta-interaktiv/react-masthead'
import Cover from '../cover'
import { Waypoint } from 'react-waypoint'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Footer } from '@ta-interaktiv/react-footer'
import RunningRoute, {
  iconLeicht,
  iconLeichtSpiegelverkehrt,
  iconMittel,
  iconSchwer,
  iconHotspot,
  iconSchwerSpiegelverkehrt,
  iconMittelSpiegelverkehrt
} from '../../components/runningRoute'

// CSS
import './style.scss'

const ADDITIONAL_SHARES = 387

type Props = {
  articleId: string
}

class AppComponent extends React.Component<Props> {
  static defaultProps = {
    articleId: '19821354'
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead
          inverted
          articleId={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
        />
        <header
          className='ui vertical fitted segment'
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          <Cover
            title={
              <>
                Die schönsten Velorouten <br />
                für Familien
              </>
            }
            subtitle='Mit der Familie den Kanton Zürich im Sattel erkunden: Wir haben für Sie neun schöne Routen für eine Velotour mit Kindern zusammengestellt.'
          />

          <div className='ui very fitted vertical segment'>
            <div className='ui container'>
              <p className='ta secondary caption'>
                Auch in der Stadt ist eine Velotour mit Kindern möglich. Hier
                bei der Fahrt übers Viadukt.
              </p>
            </div>
          </div>
        </header>

        <div className='ui vertical fitted segment'>
          <div className='ui text container'>
            <p className='ta author' style={{ paddingTop: '2em' }}>
              Von Ev Manz, Emil Bischofberger und Patrick Vögeli
            </p>
            <p>
              Mit Kindern auf dem Velo die Landschaft zu erkunden, gehört zu den
              schönsten Familienabenteuern. Alle kommen auf ihre Rechnung: Die
              Kinder können in gemächlichem Tempo die Landschaft erkunden, die
              Eltern etwas an ihrer Kondition arbeiten. Zudem macht ein Tag an
              der frischen Luft jedes Kindergeschrei erträglicher. Lockt als
              Zwischenziel eine Minigolfanlage, ein attraktiver Spielplatz oder
              gar ein Zeltplatz am See, radeln selbst die Kleinsten gern. Weit
              muss es für ein solches Erlebnis nicht gehen. Rund um Zürich
              findet sich für Familien in jeder (Alters-)Konstellation eine
              Tour. Oft folgen sie einem Gewässer, weil es in der Natur der
              Sache liegt, dass Ufer flach sind. Und für eine Abkühlung muss man
              so erst noch keine Badi suchen.
            </p>
            <p>
              Die Touren sind alle von Zürich aus geplant. Teilweise muss für
              die An- oder Rückreise der ÖV benutzt werden. Rechnet man dafür
              genügend Zeit ein, wird das selbst mit Kindern und Rädern nicht zu
              einem Stressmoment.
            </p>
            <p>
              Ach ja, selbstverständlich kann man alle Touren auch ohne Kinder
              unternehmen. Sie sind auch so schön, anders schön.
            </p>
            <p>Gute Fahrt!</p>

            <p className=''>&nbsp;</p>
            <p className=''>&nbsp;</p>
          </div>

          <RunningRoute
            routeTitle='1. Ins Ausland, dann auf die Fähre'
            routeSubtitle='Rafz – Nack (D) – Ellikon – Andelfingen (Route 95)'
            level='mittel'
            time='3 h'
            distance='19,2 km (240 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 7 Jahren
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-rafz-andelfingen.gpx'
            downloadFilename='track-rafz-andelfingen'
            lng='8.60964'
            lat='47.60177'
            lngFirstCorner='8.54023'
            latFirstCorner='47.611468'
            lngLastCorner='8.68001'
            latLastCorner='47.59143'
            mobileZoom='13'
            desktopZoom='15'
            markerPositionLng='8.54023'
            markerPositionLat='47.611468'
            getStyle='mittelTrack'
            iconStart={iconMittel}
            iconHotspot={iconHotspot}
            listHotspots={[
              {
                lat: 47.59358,
                lng: 8.60358,
                name: 'Naturschutzgebiet Thurauen'
              }
            ]}
            track={require('../main/track-rafz-andelfingen.json')}
            gettingThere={
              <>
                <span className='bold'>An-/Rückreise</span> <br />
                Hin bis Rafz (S9), zurück ab Andelfingen (S12).
              </>
            }
            text={
              <>
                Warum nicht einmal mit Kindern und den Velos auf eine
                historische, internationale Personenfähre? Zwischen dem
                deutschen Nack und der Zürcher Gemeinde Ellikon besteht seit dem
                Jahr 1500 eine Fährverbindung. Auf dem Fährschiff Rüedifaar,
                seit 40 Jahren in Betrieb, werden Velos samt Anhänger
                transportiert.
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Fährbetrieb von 1. April bis 15. Oktober jeweils von 9 bis 19
                Uhr (ausser 12–12.45 Uhr). Tour lässt sich ausbauen mit Besuch
                des Naturschutzgebietes Thurauen in Flaach.
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Am Schweizer Rheinufer in Ellikon locken im Garten des Rhygarte
                mit Sicht auf den Rhein Fischknusperli und Spielplatz. Ohnehin
                ist der schmucke Weiler am Rhein, der zur Gemeinde Marthalen
                gehört, eine Reise wert.
              </>
            }
          />

          <RunningRoute
            routeTitle='2. Gegen den Strom mit Minigolf und Flugi'
            routeSubtitle='Glattfelden – Bülach – Flughafen – Zürich (Route 29)'
            level='mittel'
            time='3 h'
            distance='20,8 km (160 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 5 Jahren
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-glattfelden-flughafen.gpx'
            downloadFilename='track-glattfelden-flughafen'
            lng='8.52658'
            lat='47.50305'
            lngFirstCorner='8.49097'
            latFirstCorner='47.55942'
            lngLastCorner='8.55782'
            latLastCorner='47.43765'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.502716'
            markerPositionLat='47.559887'
            getStyle='mittelTrack'
            iconStart={iconMittel}
            iconHotspot={iconHotspot}
            listHotspots={[
              { lat: 47.522053, lng: 8.525667, name: 'Minigolf-Anlage Hirslen' }
            ]}
            track={require('../main/track-glattfelden-flughafen.json')}
            gettingThere={
              <>
                <span className='bold'>An-/Rückreise</span> <br />
                Hin nach Glattfelden (S9), zurück ab Flughafen (Tram 10).
              </>
            }
            text={
              <>
                Es gibt für Kinder keine einfacheren Velotouren, als wenn sie
                immer geradeaus fahren können. Wenn sie das einen Fluss entlang
                tun können, ist das auch alles andere als langweilig. Die Glatt
                schlängelt sich zuerst naturbelassen durch die Landschaft und
                wird dann schnurgerade. Dazwischen sind Treffsicherheit und
                genaues Beobachten gefordert.
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Am Wochenende viel Veloverkehr
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Die Minigolf-Anlage Hirslen kurz vor Bülach (täglich geöffnet)
                bietet sich für einen Halt an. Davor gibt es an der Glatt
                diverse hübsche Plätze zum Grillieren und Baden. Am Flughafen
                lässt es sich herrlich im Gras liegen, den Flugzeugen beim
                Starten und Landen zusehen und mental abheben.
              </>
            }
          />

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '20ContentRead'
                })
              }
            }}
          />

          <RunningRoute
            routeTitle='3. In zwei Tagen an Kloster und Burg vorbei'
            routeSubtitle='Bauma – Turbenthal – Kyburg – Winterthur (Route 53)'
            level='mittel'
            time='4 h'
            distance='30 km (220 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 7 Jahren
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-bauma-winterthur.gpx'
            downloadFilename='track-bauma-winterthur'
            lng='8.79403'
            lat='47.43345'
            lngFirstCorner='8.70815'
            latFirstCorner='47.49918'
            lngLastCorner='8.88005'
            latLastCorner='47.36639'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.879313'
            markerPositionLat='47.367583'
            getStyle='mittelTrack'
            iconStart={iconMittelSpiegelverkehrt}
            iconHotspot={iconHotspot}
            listHotspots={[
              { lat: 47.390029, lng: 8.859631, name: 'Camping Saland' },
              { lat: 47.458616, lng: 8.743409, name: 'Schloss Kyburg' }
            ]}
            track={require('../main/track-bauma-winterthur.json')}
            text={
              <>
                Für diese Tour packen wir so viel aufs Rad, dass wir gleich über
                Nacht bleiben können. Am ersten Tag steht das Zelten im
                Vordergrund, am zweiten das Radeln, vorbei an den tibetischen
                Gebetsfahnen in Rikon, wo das erste tibetisch-buddhistische
                Kloster ausserhalb Asiens steht, und der markanten Kyburg auf
                der Anhöhe oberhalb der Töss.
              </>
            }
            gettingThere={
              <>
                <span className='bold'>An-/Rückreise</span> <br />
                Hin nach Wetzikon oder Pfäffikon (S-Bahn), von da Bus. Zurück ab
                Winterthur (S-Bahn/IC).
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Camping Saland: ganzjährig. Kyburg: 31. März bis 31. Oktober, Di
                bis So 10 bis 17.30 Uhr
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Der Campingplatz Saland zwischen Bauma und Turbenthal ist das
                sonnige und ruhige Juwel für Zeltbegeisterte direkt an der Töss.
                Zum Abschluss der Tour lohnt sich ein Besuch in der Kyburg, wo
                man ins Mittelalter eintauchen kann. Die Velos lassen wir dafür
                beim Veloweg stehen und kraxeln zu Fuss zur Burg hoch.
              </>
            }
          />

          <RunningRoute
            routeTitle='4. Rund ums Naturparadies'
            routeSubtitle='Uster – Uster'
            level='leicht'
            time='2 h 30 min'
            distance='21,1 km (110 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 4 Jahren
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-greifensee.gpx'
            downloadFilename='track-greifensee'
            lng='8.68165'
            lat='47.34789'
            lngFirstCorner='8.64494'
            latFirstCorner='47.37755'
            lngLastCorner='8.71652'
            latLastCorner='47.31912'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.716346'
            markerPositionLat='47.347521'
            getStyle='leichtTrack'
            iconStart={iconLeichtSpiegelverkehrt}
            iconHotspot={iconHotspot}
            listHotspots={[
              {
                lat: 47.321598,
                lng: 8.705507,
                name: 'Naturstation Silberweide'
              }
            ]}
            track={require('../main/track-greifensee.json')}
            text={
              <>
                Der Greifensee ist der perfekte Ort, um mit Kindern die Freizeit
                zu verbringen. Nicht nur, weil es in der geschützten Uferregion
                keine Autos hat, sondern auch, weil die Region Natur pur bietet.
                400 Pflanzen- und 120 Zugvogelarten kann man da bewundern, zum
                Beispiel den wunderbar farbigen Eisvogel.
              </>
            }
            gettingThere={
              <>
                <span className='bold'>An-/Rückreise</span> <br />
                Mit der S-Bahn von/nach Uster
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Ausstellungsraum Silberweide: Mi und Fr bis So geöffnet. Am
                Wochenende sind diverse Besenbeizen rund um den See geöffnet,
                dann ist der Weg aber auch besonders bevölkert.
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Am Südostende des Sees empfiehlt sich ein Besuch der
                Naturstation Silberweide. Ein Erlebnispfad führt durch die
                Riedlandschaft den Biberpfad entlang zu den Storchennestern. Von
                der Beobachtungshütte aus kann man den Vögeln zusehen, den
                Barfussweg ausprobieren oder auf dem Abenteuerspielplatz
                spielen.
              </>
            }
          />

          <RunningRoute
            routeTitle='5. Im verwunschenen Land der Kobolde'
            routeSubtitle='Bremgarten – Meerenschwand – Cham (Route 77)'
            level='mittel'
            time='4 h'
            distance='31,5 km (250 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 8 Jahren
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-bremgarten-cham.gpx'
            downloadFilename='track-bremgarten-cham'
            lng='8.40145'
            lat='47.27589'
            lngFirstCorner='8.32277'
            latFirstCorner='47.35785'
            lngLastCorner='8.47341'
            latLastCorner='47.17570'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.336733'
            markerPositionLat='47.35442'
            getStyle='mittelTrack'
            iconStart={iconMittel}
            iconHotspot={iconHotspot}
            listHotspots={[
              { lat: 47.213538, lng: 8.423899, name: 'Kloster Frauenthal' }
            ]}
            track={require('../main/track-bremgarten-cham.json')}
            text={
              <>
                «Zuerst pedalen, dann staunen» lautet das Motto dieser Tour. Die
                Kantonsgrenze entlang geht es zur einmalig verwunschenen
                Moorlandschaft im Reussspitz. Wenn Feen und Kobolde irgendwo ihr
                Zuhause haben, dann hier, zwischen Auen und alten Bäumen. Wer
                genug lange nach ihnen sucht, wird sie sicher finden. Aber auch
                für die Grossen bietet sich in der Nähe etwas.
              </>
            }
            gettingThere={
              <>
                <span className='bold'>Anreise</span> <br />
                Hin ab Zürich Enge (Bus 444/Mo bis Sa) oder nach Dietikon
                (S-Bahn) und von da S17. Zurück Cham via Zug (S-Bahn).
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Kloster Frauenthal. Hofladen Mo bis So 13.30 bis 16.30 Uhr.
                Friesenhof: Pflücken gemäss Angaben im Internet. Anfahrt nach
                Bremgarten eher umständlich.
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Nach dem Naturspektakel am Reussspitz lohnt sich ein Besuch im
                Kloster Frauenthal. Auf einer Insel in der Lorze leben seit 1231
                Zisterzienserinnen, die auch einen Hofladen mit Süssem und
                Gebranntem führen. Zuletzt lassen sich auf dem Friesenhof in
                Friesencham Früchte selber pflücken.
              </>
            }
          />

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '50ContentRead'
                })
              }
            }}
          />

          <RunningRoute
            routeTitle='6. Fast ein Pass oder der allererste Triathlon'
            routeSubtitle='Zürich – Felsenegg (via Seilbahn) – Türlersee – Stallikon – Zürich'
            level='schwer'
            time='5 h'
            distance='43 km (390 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 12 Jahren
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-albis-tuerlersee.gpx'
            downloadFilename='track-albis-tuerlersee'
            lng='8.48624'
            lat='47.33251'
            lngFirstCorner='8.42701'
            latFirstCorner='47.39674'
            lngLastCorner='8.55281'
            latLastCorner='47.26853'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.539673'
            markerPositionLat='47.377213'
            getStyle='schwerTrack'
            iconStart={iconSchwerSpiegelverkehrt}
            iconHotspot={iconHotspot}
            listHotspots={[
              { lat: 47.267808, lng: 8.510257, name: 'Camping Strandbad' }
            ]}
            track={require('../main/track-albis-tuerlersee.json')}
            gettingThere={
              <>
                <span className='bold'>Anreise</span> <br />–
              </>
            }
            text={
              <>
                Die erste Passfahrt ist das Highlight jeder Kindervelokarriere.
                Rund um Zürich gäbe es einige zu erklimmen, doch die meisten
                will man Kindern wegen des Verkehrs nicht zumuten. Wir bieten
                eine sichere Variante, ohne viel Steigung – wir überwinden sie
                mit der Felsenegg-Seilbahn und rollen dann den Albispass
                hinunter. Wer noch Energie hat, kann die Tour leicht zu einem
                kleinen Triathlon ausbauen: mit einem Schwumm im Türlersee und
                einem Wettrennen um diesen herum.
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Bei der Abfahrt vom Albispass hinunter zum Türlersee ist
                Vorsicht geboten, das Bremsen kann Kinderhände ermüden!
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Am Türlersee lässt sich herrlich aktiv verweilen. Man kann
                einfach nur baden (für 5 Franken in der Badi beim Camping) oder
                über den See schwimmen (Stege gibt es zahlreiche). Die Tour
                lässt sich mit Übernachtung auf dem Camping auch auf zwei Tage
                ausdehnen. Dann ist das Mitnehmen der Fischerrute empfohlen.
              </>
            }
          />

          <RunningRoute
            routeTitle='7. Reclaim the Streets'
            routeSubtitle='Bürkliplatz – Zürihorn – Platzspitz – Viadukt – Hardbrücke – Sihlufer – Bürkliplatz'
            level='mittel'
            time='2 h 30 min'
            distance='16 km (70 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 7 Jahren
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-reclaim-the-streets.gpx'
            downloadFilename='track-reclaim-the-streets'
            lng='8.53486'
            lat='47.37257'
            lngFirstCorner='8.51175'
            latFirstCorner='47.39248'
            lngLastCorner='8.55807'
            latLastCorner='47.35265'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.540842'
            markerPositionLat='47.366247'
            getStyle='mittelTrack'
            iconStart={iconMittel}
            iconHotspot={iconHotspot}
            listHotspots={[
              { lat: 47.353173, lng: 8.55229, name: 'Heureka von Tinguely' },
              { lat: 47.374964, lng: 8.517128, name: 'Gelateria di Berna' }
            ]}
            track={require('../main/track-reclaim-the-streets.json')}
            gettingThere={
              <>
                <span className='bold'>Anreise</span> <br />–
              </>
            }
            text={
              <>
                Es liegt nicht auf der Hand, mit den Kindern eine Velotour durch
                Zürich zu unternehmen. Doch am Sonntagvormittag ist die Stadt so
                ruhig, dass selbst die wenigen Verkehrshotspots auf der Route
                problemlos passierbar werden. Und ehrlich: Was gibt es
                Schöneres, als der Stadt an verschiedenen Orten beim Aufwachen
                zuzusehen.
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Die Gelateria di Berna liegt an der Strecke – öffnet aber erst
                um 12 Uhr. Kürzere Variante: Ohne Schlaufe ins Seefeld ist die
                Route 4 Kilometer kürzer.
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Es gibt unzählige Dinge zum Entdecken und Motivieren. Die
                Heureka von Tinguely am Zürihorn. Die Aussicht auf die
                Flussbadenden am Letten oder die ersten Gummiböötler. Die Fahrt
                übers Viadukt. Der Gleisbogen und die grosse Passerelle. Die
                Aussicht von der Hardbrücke aufs grosse Gleisfeld. Und der
                Ulmberg-Velotunnel, in dem es so schön hallt.
              </>
            }
          />

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '75ContentRead'
                })
              }
            }}
          />

          <RunningRoute
            routeTitle='8. Schussfahrt zurück in die Stadt'
            routeSubtitle='Horgenberg – Thalwil – Zürich'
            level='leicht'
            time='2 h'
            distance='17 km (50 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 7 Jahren
                <span className='mobile hidden'>
                  {' '}
                  (sollten verkehrsgewohnt sein)
                </span>
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-horgen-zuerich.gpx'
            downloadFilename='track-horgen-zuerich'
            lng='8.65174'
            lat='47.23512'
            lngFirstCorner='8.588011'
            latFirstCorner='47.247631'
            lngLastCorner='8.52723'
            latLastCorner='47.370881'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.588011'
            markerPositionLat='47.247631'
            getStyle='leichtTrack'
            iconStart={iconLeichtSpiegelverkehrt}
            iconHotspot={iconHotspot}
            listHotspots={[
              { lat: 47.300951, lng: 8.551636, name: 'Park im Grüene' }
            ]}
            track={require('../main/track-horgen-zuerich.json')}
            gettingThere={
              <>
                <span className='bold'>Anreise</span> <br />
                S8 bis Horgen, Bus 150 bis Horgenberg Wührenbach
              </>
            }
            text={
              <>
                Auf dieser Tour gewinnt, wer am wenigsten in die Pedalen treten
                muss – es geht nämlich auf Nebenstrassen stets leicht bergab.
                Die Kleinsten sind in dieser Disziplin besonders gut. Der
                Zwischenstopp im Park im Grünen ist zudem die perfekte
                Motivation. Gestärkt geht es ohne viel Verkehr zurück in die
                Stadt. Und vor der Tour lässt sich auf dem Horgenberg ein Blick
                in den Pferdestall werfen oder am Weiher picknicken.
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Park im Grünen in Rüschlikon, Kasperlitheater bei schönem Wetter
                während der Sommerferien täglich um 15 Uhr (gratis); dazu
                Eselreiten, Minizug, Spielplatz, Becken zum Planschen, Wiese und
                Restaurant.
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Für Kinder ist der Park im Grünen ein Paradies. Während der
                Sommerferien wird da unter anderem täglich ein Kasperlitheater
                aufgeführt.
              </>
            }
          />

          <RunningRoute
            routeTitle='9. Ganz nah am Zürichsee'
            routeSubtitle='Horgen – Au – Wädenswil – Richterswil'
            level='leicht'
            time='2 h'
            distance='11,3 km (20 Hm)'
            // elevationGain='~0 Hm'
            start={
              <>
                <b>Alter:</b> ab 4 Jahren
                <span className='mobile hidden'>
                  /nach dem Wechsel aufs Pedalenvelo
                </span>
              </>
            }
            downloadLink='https://interaktiv.tagesanzeiger.ch/2019/familienvelotouren/tracks/track-horgen-richterswil.gpx'
            downloadFilename='track-horgen-richterswil'
            lng='8.65174'
            lat='47.23512'
            lngFirstCorner='8.5955'
            latFirstCorner='47.261978'
            lngLastCorner='8.707986'
            latLastCorner='47.208259'
            mobileZoom='13'
            desktopZoom='14'
            markerPositionLng='8.5955'
            markerPositionLat='47.261978'
            getStyle='leichtTrack'
            iconStart={iconLeicht}
            iconHotspot={iconHotspot}
            listHotspots={[
              { lat: 47.249661, lng: 8.646197, name: 'Halbinsel Au' }
            ]}
            track={require('../main/track-horgen-richterswil.json')}
            gettingThere={
              <>
                <span className='bold'>An-/Rückreise</span> <br />
                Mit der S-Bahn bis Horgen/ab Richterswil
              </>
            }
            text={
              <>
                Die Seestrasse rund um den Zürichsee ist viel zu stark befahren
                für einen Velofamilienausflug. Doch auf dem Abschnitt zwischen
                Horgen und Richterswil verläuft der Uferweg zwischen See und
                Bahnlinie, getrennt vom Autoverkehr. Hier ist man dem Wasser so
                nah, wie sonst nur selten am Zürichseeufer. Warum nicht einmal
                vom Velo aus alle Enten zählen? Acht geben muss man hier einzig
                auf die Spaziergänger, weshalb dies eher eine Tour für unter der
                Woche ist.
              </>
            }
            textVarious={
              <>
                <span className='bold'>Diverses</span> <br />
                Die Tour ist in beide Richtungen möglich. Tipp: Windrichtung
                beachten und sich von diesem antreiben lassen!
              </>
            }
            textHighlightsTitle={<>Tipp</>}
            textHighlightsDescription={
              <>
                Die Halbinsel Au lädt zum Verweilen oder zu einem
                Entdeckungsspaziergang ein. Zudem gibt es unterwegs mehrere
                Spielplätze, Strandbeizli und Badis, die sich für eine Pause
                anbieten.
              </>
            }
          />

          <div className='ui text container'>
            <div className="note-wrapper">
              <div className="note">Dieser Artikel erschien erstmals am <nobr>19. Juli 2019.</nobr> Wir publizieren ihn hier nochmals in aktualisierter Form.</div>
            </div>
          </div>
        </div>

        {/* <p className='spaced'>&nbsp;</p> */}

        <Footer
          articleId={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
          credits={[
            [
              'Programmierung und Gestaltung',
              'Patrick Vögeli, Interaktiv-Team'
            ],
            ['Text und Recherche', 'Ev Manz und Emil Bischofberger']
          ]}
          questions={[
            'Wie nützlich sind die Streckenvorschläge?',
            'Wie gefällt Ihnen die Gestaltung?',
            'Funktionierte die technische Umsetzung?'
          ]}
          starColor='blue'
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
